import * as React from 'react'
import { observer } from 'mobx-react'
import './dropdown.scss'

export interface IDropdownOption {
  label: string
  value: any
}

interface IProps {
  className?: string
  optionClickHandler: ((val: IDropdownOption) => void)
  options: IDropdownOption[]
  showTriangle?: boolean
  trianglePosition?: React.CSSProperties
  trigger: JSX.Element
}

interface IState {
  showDropdown: boolean
}

@observer
export class Dropdown extends React.Component<IProps, IState> {
  baseClass: string = 'dropdown'
  dataDropdownTriggerIdentifier: string = 'data-dropdown-trigger'

  state: IState = {
    showDropdown: false
  }

  componentDidMount(): void {
    document.addEventListener('click', this.handleUnclick)
  }

  componentWillUnmount(): void {
    document.removeEventListener('click', this.handleUnclick)
  }

  handleUnclick = (e: Event): void => {
    if (this.state.showDropdown && !(e.target as HTMLElement).hasAttribute(this.dataDropdownTriggerIdentifier)) {
      this.toggleDropdown()
    }
  }

  toggleDropdown(): void {
    this.setState({ showDropdown: !this.state.showDropdown })
  }

  get renderTrigger(): JSX.Element {
    const { trigger } = this.props
    return React.cloneElement(trigger, {
      onClick: (): void => this.toggleDropdown(),
      [this.dataDropdownTriggerIdentifier]: true
    })
  }

  render(): React.ReactNode {
    const {
      className,
      optionClickHandler,
      options,
      showTriangle
    } = this.props
    const { showDropdown } = this.state

    return (
      <div className={`${this.baseClass} ${className ? className : ''}`}>
        {this.renderTrigger}
        {showDropdown && (
          <>
            <div className={`${this.baseClass}__container`}>
              {options.map((option, i) => (
                <React.Fragment key={i}>
                  <div className={`${this.baseClass}__side-menu`} key={option.label}>
                    <button
                      className={`${this.baseClass}__option`}
                      onClick={(): void => optionClickHandler(option)}
                    >
                      {option.label}
                    </button>
                  </div>
                  {i !== options.length - 1 && <hr className={`${this.baseClass}__hr`}/>}
                </React.Fragment>
              ))}
            </div>
            {showTriangle && (
              <div
                className={`${this.baseClass}__triangle`}
              />
            )}
          </>
        )}
      </div>
    )
  }
}
